// extracted by mini-css-extract-plugin
export default {"videomodal":"video_videomodal__YYm9Y","close":"video_close__ravWl","videoClose":"video_videoClose__laO6c"};